import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function WebsiteSoftwareDevelopment() {
  return (
    <>
      <Breadcrumb title="Website & Software Development" />

      <div className="page-service-single">
        <div className="container">

          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="service-single-content">

                {/* Featured Image */}
                <div className="service-featured-image">
                  <figure className="image-anime reveal">
                    <img
                      src="/assets/images/web2.png"
                      alt="Website & Software Development"
                      loading="lazy"
                    />
                  </figure>
                </div>

                {/* Entry Content */}
                <div className="service-entry">
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    We build secure, scalable, and user-centric websites and
                    mobile applications designed for modern healthcare and
                    pharma ecosystems. Our solutions focus on performance,
                    integration, and compliance while delivering seamless
                    digital experiences.
                  </p>

                  <h4 className="mb-2">What we do</h4>
                  <ul>
                    <li>Responsive website and mobile app development</li>
                    <li>API, CRM, and third-party system integration</li>
                    <li>Custom CMS and enterprise software solutions</li>
                    <li>Performance, security, and compliance optimization</li>
                  </ul>

                  <h4 className="mb-2 mt-2">Value we create</h4>
                  <ul>
                    <li>Improved user engagement and experience</li>
                    <li>Seamless system connectivity</li>
                    <li>Reliable, future-ready digital platforms</li>
                  </ul>
                </div>

              </div>
            </div>
          </div>

          {/* Sidebars */}
          <div className="row">
            <ServiceSidebar
              title="Website Development"
              items={[
                "Custom website design (UI/UX)",
                "Responsive web development",
                "Corporate & business websites",
                "E-commerce websites",
                "Landing pages",
                "Multi-language websites",
                "Web portals",
                "Website redesign & modernization",
                "Speed optimization",
                "WCAG accessibility compliance",
                "Maintenance & support",
                "Security implementation",
              ]}
            />

            <ServiceSidebar
              title="Mobile App Development"
              items={[
                "Progressive Web Apps (PWA)",
                "Performance optimization",
                "Mobile security & data protection",
                "Cloud backend integration",
                "Payment gateway integration",
                "Push notifications",
                "Analytics & tracking",
                "Third-party APIs & SDKs",
                "App migration",
                "IoT-enabled apps",
                "AI & ML-powered apps",
                "AR/VR applications",
              ]}
            />

            <ServiceSidebar
              title="Web Application Development"
              items={[
                "Custom web apps",
                "Cloud-native apps",
                "Role-based dashboards",
                "Enterprise portals",
                "High-performance architecture",
                "Secure authentication systems",
              ]}
            />

            <ServiceSidebar
              title="API Integration"
              items={[
                "Third-party API integration",
                "Custom API development",
                "API documentation & versioning",
                "API testing & QA",
                "Real-time data sync",
                "API security (OAuth, tokens)",
              ]}
            />

            <ServiceSidebar
              title="System Integration"
              items={[
                "ERP integrations",
                "HRMS integrations",
                "Inventory & POS integration",
                "Marketing platform integration",
                "Billing & invoicing systems",
                "Custom middleware",
              ]}
            />

            <ServiceSidebar
              title="CRM Integration"
              items={[
                "CRM setup & onboarding",
                "CRM customization",
                "Website + CRM integration",
                "Lead automation workflows",
                "Sales pipeline setup",
                "Marketing automation",
                "CRM data migration",
                "CRM APIs",
                "Reporting dashboards",
              ]}
            />
          </div>

        </div>
      </div>
    </>
  );
}

/* ✅ Reusable Sidebar Component */
function ServiceSidebar({ title, items }) {
  return (
    <div className="col-lg-4">
      <div className="service-sidebar">
        <div className="services-list-box wow fadeInUp" data-wow-delay="0.5s">
          <h3>{title}</h3>
          <ul>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
